<template>
  <el-dialog title="微信扫码登录" width="500px" :visible.sync="formVisible" :close-on-click-modal="false" @close="closeFun">
    <div>
      <div class="wxpaydv">
        <div class="pay-msg">请使用微信扫一扫!</div>
        <div class="pay-wars">登录过程中请勿刷新页面或关闭浏览器!!!</div>
        <div ref="wxqrcode" class="wxqrcode" v-show="!loginOk"></div>
        <div style="line-height:200px" v-show="loginOk">登录成功,正在刷新页面</div>
        <div class="wxpayimg"><img src="//static.jazpan.com/img/weixinlg.png"></div>
      </div>
    </div>
    <!--工具条-->
    <div slot="footer" class="dialog-footer">
      <el-button @click.native="formVisible = false">取消</el-button>
      <el-button type="primary" @click="onWaitFun(false)" :loading="formLoading">我已扫码完成</el-button>
    </div>
  </el-dialog>
</template>


<script>
export default {
  data () {
    return {
      formVisible: false,
      formLoading: false,
      vwid: '',
      loginOk: false,
    }
  },
  methods: {
    genUUID () {
      function S4 () {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
      }
      return (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4());
    },
    close () {
      if (this.formVisible == true)
        this.formVisible = false;
    }, show () {
      this.formVisible = true;

      this.vwid = this.genUUID();
      setTimeout(this.showQrcode, 100);
    }, showQrcode () {
      this.$refs.wxqrcode.innerHTML = '';
      let url = 'http:'+this.$ApiUrl + "/lg/wx/goto?vwid=" + this.vwid;
      new QRCode(this.$refs.wxqrcode, {
        text: url,
        width: 200,
        height: 200,
      });
      this.onWaitFun(true);
    }, closeFun (e) {
      // console.log('closeFun', e);
      this.$emit('close');
    }, onWaitFun (cf) {
      this.$post('/lg/wx/wait', { vwid: this.vwid }).then(res => {
        this.$emit('submitOK');
        this.loginOk = true;
        this.formLoading = true;
        // this.formVisible = false;
      }).catch(err => {
        if (cf && this.formVisible)
          setTimeout(() => { this.onWaitFun(cf) }, 100)
      });
    }
  }
};

</script>

<style>
.wxqrcode {
  margin-top: 20px;
}

.wxqrcode img {
  margin: auto;
}
</style>
<style scoped>
.wxpaydv {
  text-align: center;
  margin: 20px;
}

.pay-msg {
  color: #fd482c;
}

.pay-wars {
  color: #fd8f1c;
}

.wxpayamt {
  margin-top: 20px;
  color: #f60;
  font-weight: bold;
  font-size: 18px;
}

.wxpayimg {
  margin-top: 10px;
}

.wxpayimg img {
  width: 100px;
}
</style>



// WEBPACK FOOTER //
// WxLoginDlg.vue?1382b122